/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Carousel } from '@msdyn365-commerce/components';
import { Module } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICarouselViewProps } from '@msdyn365-commerce-modules/carousel';
import { ICarouselProps } from '../definition-extensions/carousel.ext.props.autogenerated';

/**
 * Returns item slots.
 * @returns Array of item slots.
 * @param props -Props.
 */
const retrieveItems = (props: ICarouselViewProps): React.ReactNode[] => {
    const {
        context: {
            request: {
                user: { isAuthenticated }
            }
        }
    } = props;
    let items: any[] = [];
    if (isAuthenticated) {
        for (let i = 0; i <= props.slots.content.length; i++) {
            const temp = props.slots.content[i] as JSX.Element;
            if (temp) {
                if (temp.props.config.showOnlyForGuest && temp.props.config.showOnlyForGuest === true) {
                    console.log();
                } else {
                    items[i] = temp;
                }
            }
        }
    } else {
        for (let i = 0; i <= props.slots.content.length; i++) {
            const temp = props.slots.content[i] as JSX.Element;
            if (temp) {
                if (temp.props.config.showOnlyForloggedIn && temp.props.config.showOnlyForloggedIn === true) {
                    console.log();  
                } else {
                    items[i] = temp;
                }
            }
        }
    }
    items = items.filter(item => Object.keys(item).length !== 0);

    return items;
};
const CarouselView: React.FC<ICarouselViewProps & ICarouselProps<{}>> = props => {
    const {
        config: { loggedInBanner, showBannerForLoggedInAndGuest },
        context: {
            request: {
                user: { isAuthenticated }
            }
        }
    } = props;
    if ((isAuthenticated && loggedInBanner) || (!isAuthenticated && !loggedInBanner) || showBannerForLoggedInAndGuest) {
        const items = retrieveItems(props);
        const orignalItems = props.slots && props.slots.content && props.slots.content.length > 0 ? props.slots.content : [];
        const [customActiveIndex, setCustomActiveIndex] = React.useState<number>(0);
        let customLogic = false;
        if (orignalItems.length > items.length) {
            customLogic = true;
        }
        const customPrevious = () => {
            const previousIndex =
                customActiveIndex === 0
                    ? items.length - 1
                    : customActiveIndex === items.length - 1
                    ? customActiveIndex - 1
                    : customActiveIndex - 1;
            setCustomActiveIndex(previousIndex);
        };
        const customNext = () => {
            const nextIndex = customActiveIndex === items.length - 1 ? 0 : customActiveIndex + 1;
            setCustomActiveIndex(nextIndex);
        };

        return (
            <Module {...props.carouselContainer} {...props.renderModuleAttributes(props)}>
                <Carousel
                    className={classnames(props.closeAnimation)}
                    activeIndex={customLogic ? customActiveIndex : props.activeIndex}
                    next={customLogic ? customNext : props.next}
                    previous={customLogic ? customPrevious : props.previous}
                    pause={props.config.pauseOnHover ? 'hover' : false}
                    ride={props.config.autoplay ? 'carousel' : undefined}
                    autoplay={props.config.autoplay}
                    interval={props.config.interval}
                    transitionType={props.config.transitionType ? props.config.transitionType : undefined}
                    items={retrieveItems(props)}
                    hideFlipper={props.config.hideFlipper}
                    dismissEnabled={props.config.dismissEnabled}
                    onIndicatorsClickHandler={props.onIndicatorsClickHandler}
                    handleDismissCarousel={props.handleDismissCarousel}
                    dismissCarouselAriaText={props.resources && props.resources.ariaLabelForDismissButton}
                    indicatorAriaText={props.resources && props.resources.ariaLabelForSlide}
                    directionTextPrev={props.resources && props.resources.flipperPrevious}
                    directionTextNext={props.resources && props.resources.flipperNext}
                    handleOnExited={props.handleOnExited}
                    handleOnExiting={props.handleOnExiting}
                    telemetryContent={props.telemetryContent}
                    keyboard={props.config.keyboard}
                />
            </Module>
        );
    } else if ((isAuthenticated && !loggedInBanner) || (!isAuthenticated && loggedInBanner)) {
        return <div></div>;
    } else {
        return <div></div>;
    }
};

export default CarouselView;
